// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React from 'react';
import { Icon } from '@fluentui/react';
import { isMessageTooLong } from './SendBoxUtils';
import { _formatString } from '@internal/acs-ui-common';
import { MAXIMUM_LENGTH_OF_MESSAGE } from '../utils/SendBoxUtils';

/**
 * @private
 */
export const onRenderCancelIcon = (className: string): JSX.Element => {
  return <Icon iconName={'EditBoxCancel'} className={className} />;
};

/**
 * @private
 */
export const onRenderSubmitIcon = (className: string): JSX.Element => {
  return <Icon iconName={'EditBoxSubmit'} className={className} />;
};

/**
 * Enumeration for whether a message can be sent
 */
export type MessageState = 'OK' | 'too short' | 'too long';
function isMessageEmpty(messageText: string): boolean {
  return messageText.trim().length === 0;
}

/**
 * @private
 */
export function getMessageState(messageText: string): MessageState {
  return isMessageEmpty(messageText) ? 'too short' : isMessageTooLong(messageText.length) ? 'too long' : 'OK';
}

/**
 * @private
 */
export const getTextValidationErrorMessage = (messageState: string, tooLongString: string, tooShortString: string, imageOverflow: boolean = false): string | undefined => {
  return messageState === 'too long' || imageOverflow ? _formatString(tooLongString, {
    limitNumber: `${MAXIMUM_LENGTH_OF_MESSAGE}`
  }) : messageState === 'too short' ? tooShortString : undefined;
};